"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelectPayerSeachState = exports.useInitialSortedAndGroupedPayerOptions = void 0;
var _react = require("react");
var _utils = require("../../utils");
var _ = require("./..");
var _utils2 = require("./utils");
var _lodash = require("lodash");
var _utils3 = require("./SelectPayerMobile/utils");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useInitialSortedAndGroupedPayerOptions = function useInitialSortedAndGroupedPayerOptions() {
  var _user$profile2;
  var _useDictionaries = (0, _utils.useDictionaries)(),
    payersLoading = _useDictionaries.payersReq.loading,
    payers = _useDictionaries.payers;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var shouldAddPayerIdInLabel = (0, _utils.isAdmin)(user);
  var sortedOptions = (0, _react.useMemo)(function () {
    var _user$profile;
    return (0, _utils2.getInitialSortedPayerOptions)(payers, (_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.state);
  }, [payers, user]);
  var _getReactSelectOption = (0, _utils2.getReactSelectOptionGroups)(sortedOptions, (_user$profile2 = user.profile) === null || _user$profile2 === void 0 ? void 0 : _user$profile2.state, shouldAddPayerIdInLabel),
    reactSelectCompatibleOptions = _getReactSelectOption.options,
    groupedOptions = _getReactSelectOption.groupedOptions;
  return {
    options: reactSelectCompatibleOptions,
    groupedOptions: groupedOptions,
    shouldAddPayerIdInLabel: shouldAddPayerIdInLabel,
    payersLoading: payersLoading
  };
};
exports.useInitialSortedAndGroupedPayerOptions = useInitialSortedAndGroupedPayerOptions;
var useSelectPayerSeachState = function useSelectPayerSeachState(groupedOptions) {
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    searchOptions = _useState2[0],
    setSearchOptions = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    searchValue = _useState4[0],
    setSearchValue = _useState4[1];
  var handleOptionsSearch = function handleOptionsSearch(newValue, actionMeta) {
    if (actionMeta.action === 'input-change') {
      var upperSearchValue = (0, _lodash.toUpper)(newValue);
      setSearchValue(newValue);
      if (!upperSearchValue.length) {
        applySearchOptions(groupedOptions);
        return;
      }
      var nextSearchOptions = (0, _utils3.filterAndSortOptions)(groupedOptions, upperSearchValue);
      applySearchOptions(nextSearchOptions);
    }
  };
  var applySearchOptions = (0, _react.useMemo)(function () {
    return (0, _lodash.debounce)(function (options) {
      return setSearchOptions(options);
    }, 600);
  }, [setSearchOptions]);
  return {
    searchOptions: searchOptions,
    setSearchOptions: setSearchOptions,
    searchValue: searchValue,
    setSearchValue: setSearchValue,
    handleOptionsSearch: handleOptionsSearch
  };
};
exports.useSelectPayerSeachState = useSelectPayerSeachState;